<template>
  <div>
    <!-- header-->
    <headertop></headertop>

    <div class="main">
      <div class="title">
        <h1 class="left"><i class="el-icon-notebook-2"></i> 答疑</h1>
      </div>
      <!-- 搜索框 -->
      <el-input placeholder="请输入内容" prefix-icon="el-icon-search" @keyup.enter.native="search_click()"
      	v-model.trim="question.search" style="width: 90%;margin: 0 5%;"></el-input>
      <!-- 表格 -->
      <el-table :data="question.list" stripe style="width: 90%;margin: 0 5%;" fit>
        <el-table-column sortable label="问题">
        	<template slot-scope="scope">
        		<span @click="question_show(scope.row.num)" style="cursor: pointer;">
        			{{scope.row.name}}
        		</span>
        	</template>
        </el-table-column>
        <el-table-column width="200" prop="time" sortable label="发布时间" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="block center">
        <el-pagination @size-change="(val) => handleSizeChange( val)"
          @current-change="(val) => handleCurrentChange(val)" :current-page="question.currentPage"
          :page-sizes="[10, 20, 30, 40]" :page-size="question.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="question.total">
        </el-pagination>
      </div>
    </div>
    

    <el-dialog :visible.sync="question_dialogVisible" class="question_info">
       <div class="text item" >
            <p v-html="question_info.name" style="color: #FF0000;font-size: 22px;">
            </p>
            <p class="itema" v-html="question_info.answer" style="padding:5px 0px;text-decoration:none;"></p>
            <p style="padding: 10px 0;color: #a5a5a5;font-size: 10px;">发布时间：{{question_info.time}}</p>
       </div>
    </el-dialog>

    <!-- footer -->
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        question: {
          list:[],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          search: '',
        },
        question_dialogVisible: false,
        question_info:[],
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted:function(){
      this.get_question();
    },
    methods: {
      search_click(){
        this.get_question()
      },
      get_question(){
        let _this=this;
        _this.axios.get('/v2/user_question/get_list',{
          params: {
            'keyword':_this.question.search,
            'page':_this.question.currentPage,
            'limit':_this.question.pageSize
          }
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.question.list=res.data.data.data
              _this.question.total=res.data.data.total
              _this.question.currentPage=res.data.data.current_page
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      question_show(num){
        let _this=this
        _this.axios
        .get("/v2/user_question/get_info",
        {params:{num:num}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.question_dialogVisible=true
              _this.question_info=res.data.data
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },

      handleClick(row) {
      },
      handleSizeChange(val) {
        this.question.currentPage = 1
        this.question.pageSize = val
        this.get_question()
      },
      handleCurrentChange(val) {
        this.question.currentPage = val
        this.get_question()
      },
    },
  }
</script>

<style scoped>
  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  .question_info >>> .el-dialog__body {
      padding: 0px 20px;
  }

  .question_info >>> .el-dialog__header {
      padding: 0px 20px 10px;
  }

  .title {
    padding: 20px;
    overflow: hidden;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Question/Question.vue